// LIST
export const FETCH_TOOLS = "app/TOOLS/FETCH_TOOLS";
export const FETCH_TOOLS_SUCCESS = "app/TOOLS/FETCH_TOOLS_SUCCESS";
export const FETCH_TOOLS_FAILURE = "app/TOOLS/FETCH_TOOLS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/TOOLS/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/TOOLS/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/TOOLS/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_TOOLS = "app/TOOLS/ADD_TOOLS";
export const ADD_TOOLS_SUCCESS = "app/TOOLS/ADD_TOOLS_SUCCESS";
export const ADD_TOOLS_FAILURE = "app/TOOLS/ADD_TOOLS_FAILURE";

// EDIT
export const EDIT_TOOLS = "app/TOOLS/EDIT_TOOLS";
export const EDIT_TOOLS_SUCCESS = "app/TOOLS/EDIT_TOOLS_SUCCESS";
export const EDIT_TOOLS_FAILURE = "app/TOOLS/EDIT_TOOLS_FAILURE";

// DELETE
export const DELETE_TOOLS = "app/TOOLS/DELETE_TOOLS";
export const DELETE_TOOLS_SUCCESS = "app/TOOLS/DELETE_TOOLS_SUCCESS";
export const DELETE_TOOLS_FAILURE = "app/TOOLS/DELETE_TOOLS_FAILURE";

export const GET_RESIDENT_TOOL_DATA = "app/TOOLS/GET_RESIDENT_TOOL_DATA";
export const GET_RESIDENT_TOOL_DATA_SUCCESS =
  "app/TOOLS/GET_RESIDENT_TOOL_DATA_SUCCESS";
export const GET_RESIDENT_TOOL_DATA_FAILURE =
  "app/TOOLS/GET_RESIDENT_TOOL_DATA_FAILURE";

export const SET_RESIDENT_TOOL_DATA_FILTERS =
  "app/TOOLS/SET_RESIDENT_TOOL_DATA_FILTERS";

export const UPDATE_TOOL_SEQUENCE = "app/TOOLS/UPDATE_TOOL_SEQUENCE";
export const UPDATE_TOOL_SEQUENCE_SUCCESS =
  "app/TOOLS/UPDATE_TOOL_SEQUENCE_SUCCESS";
export const UPDATE_TOOL_SEQUENCE_FAILURE =
  "app/TOOLS/UPDATE_TOOL_SEQUENCE_FAILURE";

// TOGGLE DEFAULT TOOL/CHART ON/OFF FOR A LOCATION
export const TOGGLE_TOOL_LOCATION_SETTING =
  "app/TOOLS/TOGGLE_TOOL_LOCATION_SETTING";
export const TOGGLE_TOOL_LOCATION_SETTING_SUCCESS =
  "app/TOOLS/TOGGLE_TOOL_LOCATION_SETTING_SUCCESS";
export const TOGGLE_TOOL_LOCATION_SETTING_FAILURE =
  "app/TOOLS/TOGGLE_TOOL_LOCATION_SETTING_FAILURE";

export const SEARCH_TOOLS = "app/TOOLS/SEARCH_TOOLS";
export const SEARCH_TOOLS_SUCCESS = "app/TOOLS/SEARCH_TOOLS_SUCCESS";
export const SEARCH_TOOLS_FAILURE = "app/TOOLS/SEARCH_TOOLS_FAILURE";

export const GET_TOOL_SNAPSHOTS = "app/TOOLS/GET_TOOL_SNAPSHOTS";
export const GET_TOOL_SNAPSHOTS_SUCCESS =
  "app/TOOLS/GET_TOOL_SNAPSHOTS_SUCCESS";
export const GET_TOOL_SNAPSHOTS_FAILURE =
  "app/TOOLS/GET_TOOL_SNAPSHOTS_FAILURE";
